import { useState, useEffect } from "react";
import api from "../../services/api";
import toastError from "../../errors/toastError";

const useWebhookConnections = () => {
  const [loading, setLoading] = useState(true);
  const [connections, setConnections] = useState([]);

  useEffect(() => {
    async function fetchData() {
      setLoading(true);
      try {
        const { data } = await api.get("/plugins/webhook");
        setConnections(data);
      } catch (err) {
        toastError(err);
      } finally {
        setLoading(false);
      }
    }
    fetchData();
  }, []);

  const createConnection = async (connectionData) => {
    try {
      const { data } = await api.post("/plugins/webhook", connectionData);
      setConnections((prev) => [data, ...prev]);
      return data;
    } catch (err) {
      toastError(err);
      throw err;
    }
  };

  const updateConnection = async (connectionId, connectionData) => {
    try {
      const { data } = await api.put(`/plugins/webhook/${connectionId}`, connectionData);
      setConnections((prev) =>
        prev.map((conn) => (conn.id === connectionId ? data : conn))
      );
      return data;
    } catch (err) {
      toastError(err);
      throw err;
    }
  };

  const deleteConnection = async (connectionId) => {
    try {
      await api.delete(`/plugins/webhook/${connectionId}`);
      setConnections((prev) => prev.filter((conn) => conn.id !== connectionId));
    } catch (err) {
      toastError(err);
      throw err;
    }
  };

  const regenerateToken = async (connectionId) => {
    try {
      const { data } = await api.post(`/plugins/webhook/${connectionId}/regenerate-token`);
      setConnections((prev) =>
        prev.map((conn) => (conn.id === connectionId ? data : conn))
      );
      return data;
    } catch (err) {
      toastError(err);
      throw err;
    }
  };

  return {
    connections,
    loading,
    createConnection,
    updateConnection,
    deleteConnection,
    regenerateToken
  };
};

export default useWebhookConnections;
